<template>
    <div class="box center unset">
        <div class="flex">
            <div class="flex1">
                    <p class="small_font">会员数量</p>
                    <p class="big_font">{{ nexus.total }}</p>
            </div>
        </div>
        <div class="flex" style="margin-top: 0.07rem;">
            <div class="left flex1">
                <p
                    class="small_font"
                    @click="() => changeSelectMemberType('retail')"
                >
                    零售
                </p>
                <p :class="selectMemberType === 'retail' ? 'borderBottom' : 'no_select'"></p>
            </div>
            <div class="border"></div>
            <div class="right flex1">
                <p
                    class="small_font"
                    @click="() => changeSelectMemberType('team')"
                >
                    团队
                </p>
                <p :class="selectMemberType === 'team' ? 'borderBottom' : 'no_select'"></p>
            </div>
            <div class="border"></div>
            <div class="right flex1">
                <p
                    class="small_font"
                    @click="() => changeSelectMemberType('fans')"
                >
                    粉丝
                </p>
                <p :class="selectMemberType === 'fans' ? 'borderBottom' : 'no_select'"></p>
            </div>
        </div>
        <br/>
    </div>
</template>

<script>

export default {
  props: ['nexus', 'property', 'selectMemberType', 'changeSelectMemberType'],
  name: 'Header',
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.border {
    height: .2rem;
    margin-top: 0;
}
.borderBottom {
    background: #fff;
    border-radius: 2px;
    height: .05rem;
    margin: auto;
    width: .3rem;
    margin-top: 5px;
}
.no_select {
    border-radius: 2px;
    height: .05rem;
    margin: auto;
    width: .3rem;
    margin-top: 5px;
    background: #009688;
}
</style>



// WEBPACK FOOTER //
// src/components/userMemberElement/Header.vue